export default __webpack_public_path__ + "5bcebf80693ce260f71a5d190c9efb4e.svg";